import { render, staticRenderFns } from "./GroupClassUsersListDialog.vue?vue&type=template&id=1d60b396"
import script from "./GroupClassUsersListDialog.vue?vue&type=script&lang=js"
export * from "./GroupClassUsersListDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports